import type { WorkspaceTab } from "../editor/types";

export function paneVisibility(tab: WorkspaceTab, activeTab: WorkspaceTab) {
  return activeTab === tab ? "flex" : "hidden md:flex";
}
